/** List invitations for the current session user (by email). */
export const tenantUserInvitationListMineSpec = {
    uri: '/user/tenant/invitation/mine',
    method: 'GET',
};
